import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  ListGroup
} from 'react-bootstrap'
import { CardModalView } from 'components/Sidebar'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import {
  ListItem
} from 'components/List'
import KanBoIcon from 'components/KanBoIcon'
import IncomingEmails from './components/IncomingEmails'
import { ModalCardContext } from 'components/Modal'

export class Settings extends React.Component {
  static propTypes = {
    cardId: PropTypes.number.isRequired,

    leftSidebar: PropTypes.object.isRequired,
  }

  handleIncomingEmailsClick = () => {
    this.props.leftSidebar.push(() => <ModalCardContext cardId={this.props.cardId}><IncomingEmails cardId={this.props.cardId} /></ModalCardContext>)
  }

  render () {
    return (
      <CardModalView
        title={<FormattedMessage id='SETTINGS' />}
      >
        <ListGroup>
          <ListItem
            borderedIcon
            icon={<KanBoIcon fixedWidth name='kanbo-16-incoming-mail' />}
            onClick={this.handleIncomingEmailsClick}
          >
            <FormattedMessage id='INCOMING_EMAILS' />
          </ListItem>
        </ListGroup>
      </CardModalView>
    )
  }
}

export default withLeftSidebar(Settings)
